import { Link } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";

import { IWrapperStyle } from "./interfaces";

const getStyle = (style: string | number, padding = 0) => {
    if (typeof style === "number") {
        return `${style - padding}px`;
    }
    return style;
}

export const Wrapper = styled.div<IWrapperStyle>`
    position: absolute;
    left: ${p => p.align === "center" ? 50 : 0}%;
    transform: translateX(-${p => p.align === "center" ? 50 : 0}%);
    z-index: 3;
    padding-top: 10px;
    top: ${p => getStyle(p.styles.top, 10)};
    bottom: ${p => getStyle(p.styles.bottom)};
    width: ${p => p.styles.width}px;
    ${p => p.theme.xs(css`
        left: ${p.mobileAlign === "center" ? 50 : 0}%;
        transform: translateX(-${p.mobileAlign === "center" ? 50 : 0}%);
        top: ${getStyle(p.styles.mobileTop, 10)};
        bottom: ${getStyle(p.styles.mobileBottom)};
    `)}
`;

const showAnimation = keyframes`
    0% {
        transform: scale(0.8);
        opacity: 0.6;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
`;

export const Container = styled.div<IWrapperStyle>`
    background-color: ${p => p.theme.mode === "dark" ? p.theme.c.cardBackground : p.theme.c[p.backgroundColor!]};
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow2};
    border-radius: 6px;
    min-width: 100px;
    overflow: hidden;
    transform-origin: ${p => p.styles.top !== "auto" ? "top" : p.styles.bottom ? "bottom" : "center"} ${p => p.align};
    ${p => p.theme.xs(css`
        transform-origin: 
            ${p.styles.mobileTop !== "auto" ? "top" : p.styles.mobileBottom ? "bottom" : "center"} ${p.align};
    `)}
    animation: ${showAnimation} 150ms forwards;
`;

export const Item = styled(Link)`
    display: block;
    font-size: 16px;
    font-weight: 300;
    color: ${p => p.theme.mode === "dark" ? p.theme.c.whiteOnActive : p.theme.c.grey7};
    padding: 6px 8px;
    line-height: 20px;
    margin: 0 !important;
    &:nth-child(1) {
        border-bottom: 1px solid ${p => p.theme.c.greyD};
    }

    &:hover {
        background-color: ${p => p.theme.c.boost};
        color: ${p => p.theme.c.whiteOnActive};
    }
`;